// Reads the effective plan for the caller company. Cached by React Query
// under `planSdkKeys.current()`. The Stripe webhook updates the row server-
// side, so a `queryClient.invalidateQueries(planSdkKeys.current())` from the
// BillingSuccess polling page is enough to surface a fresh plan everywhere.

import { useQuery } from '@tanstack/react-query';
import { usePlanContext } from './PlanProvider';
import { planSdkKeys } from '../api/queryKeys';
import type { EffectivePlan } from '../types';

export function useCurrentPlan() {
  const { api } = usePlanContext();
  return useQuery<EffectivePlan>({
    queryKey: planSdkKeys.current(),
    queryFn: () => api.getCurrentPlan(),
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
